import React, { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import appActions from '../../../appActions';
import DynamicInput from '../../../components/DynamicInput';
import { dateTimeTemplate, isPermissionCodeValid, objtoarr } from '../../../utils/mics';


const StoreSystemIdDetails = ({ pageId }) => {

    const { state } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const readAccess = isPermissionCodeValid(`${pageId}-R`);
    const writeAccess = isPermissionCodeValid(`${pageId}-W`);
    

    const storeSysId = useSelector((state) =>  state.storeSysId.storeSysId);

    const [record, setRecord] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);
    //const [additionalFields, setAdditonalFields] = useState([]);

    useEffect(() => {
        if (!state) return;
        const { data, isView, isEdit } = state;
        setRecord(data || {});
        setIsViewMode(isView || false);
        setIsEditMode(isEdit || false);
        // const fields =
        //     data &&
        //     data?.additionalFields !== null &&
        //     Object.keys(data?.additionalFields).length !== 0 ? objtoarr(data?.additionalFields) : [];
        // setAdditonalFields(fields);
    }, [state]);


    const handleSubmit = (data) => {
        if (data.id) {
            dispatch(appActions.STORESYSID_UPDATE_REQUEST(data));
        } else {
            dispatch(appActions.STORESYSID_CREATE_REQUEST(data));
        }
    };

    const handleRedirect = useCallback(() => {
        dispatch(appActions.STORESYSID_RESET_REQUEST());
        navigate('/ui/store-system-id-config', { replace: true });
    }, [dispatch, navigate]);

    useEffect(() => {
        if (storeSysId?.action === 'create' || storeSysId?.action === 'update') {
            handleRedirect();
        }
    }, [storeSysId, handleRedirect]);

    const formik = useFormik({
        
        initialValues: {
            id: record?.id || '',
            storeId: record?.storeId || '',
            idType: record?.idType || '',
            idMin: record?.idMin || '',
            idMax: record?.idMax || '',
            idPrefix: record?.idPrefix || '',
            idValue: record?.idValue || '',
            lastUpdatedBy: record?.lastUpdatedBy || '',
            createdOn: dateTimeTemplate(record?.createdOn) || '',
            lastUpdated: dateTimeTemplate(record?.lastUpdated) || '',
        },
        enableReinitialize: true,
        // additionalFields: additionalFields.reduce(function (acc, item) {
        //     if (item.field.trim() !== '' && item.value.trim() !== '') {
        //         acc[item.field] = item.value;
        //         return acc;
        //     }
        //     return acc;
        // }, {}),
        validate: (data) => {

            let errors = {};
            
            if (!data.storeId) {
                errors.storeId = 'Store Id is required.';
            }

            if (!data.idType) {
                errors.idType = 'Type is required.';
            }

            if (!data.idMin) {
                errors.idMin = 'Minimum is required.';
            }

            if (!data.idMax) {
                errors.idMax = 'Maximum is required.';
            }

            return errors;

        },
        onSubmit: (values) => {

            const data = {
                ...values,
                // additionalFields: additionalFields.reduce(function (acc, item) {
                //     if (item.field.trim() !== '' && item.value.trim() !== '') {
                //         acc[item.field] = item.value;
                //         return acc;
                //     }
                //     return acc;
                // }, {})
            };
            if (isEditMode) {
                data['id'] = record.id;
            }
            handleSubmit(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    // const handleDynamicInputChange = (data) => setAdditonalFields(data);

    const renderFormArea = () => {
        return (
            <div className="p-fluid formgrid grid br-2 bg-white p-2 py-4 border-round-xl shadow-1">
                
                {(isEditMode || isViewMode) && (
                    <div className="col-4 mb-3">
                        <label htmlFor="id">Id</label>
                        <InputText id="id" name="id" value={formik.values.id} onChange={formik.handleChange} disabled />
                    </div>
                )}

                <div className="col-4 mb-3">
                    <label htmlFor="storeId"> Store* </label>
                    <InputText id="storeId" name="storeId" type="number" value={formik.values.storeId} onChange={formik.handleChange}
                        className={classNames({ 'p-invalid': isFormFieldValid('storeId'), })} readOnly={isViewMode} />
                    {getFormErrorMessage('storeId')}
                </div>

               <div className="col-4 mb-2">
                    <label htmlFor="idType">Type*</label>
                    <InputText id="idType" name="idType" type='text' value={formik.values.idType} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('idType'), })} readOnly={isViewMode} />
                    {getFormErrorMessage('idType')}
                </div>

                <div className="col-4 mb-2">
                    <label htmlFor="idMin">Minimum*</label>
                    <InputText id="idMin" name="idMin" type="number" value={formik.values.idMin} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('idMin'), })} readOnly={isViewMode} />
                    {getFormErrorMessage('idMin')}
                </div>

                   <div className="col-4 mb-2">
                    <label htmlFor="idMax">Maximum*</label>
                    <InputText id="idMax" name="idMax" type="number" value={formik.values.idMax} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('idMax'), })} readOnly={isViewMode} />
                    {getFormErrorMessage('ididMaxMin')}
                </div>

                <div className="col-4 mb-2">
                    <label htmlFor="idPrefix">Prefix</label>
                    <InputText id="idPrefix"  name="idPrefix" type="number" value={formik.values.idPrefix} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>

                <div className="col-4 mb-3">
                    <label htmlFor="idValue">Current Value</label>
                    <InputText id="idValue" name="idValue" type="number" value={formik.values.idValue} onChange={formik.handleChange} readOnly={isViewMode} />
                </div>
                
                {(isEditMode || isViewMode) && (
                    <>
                        <div className="col-4 mb-3">
                            <label htmlFor="createdOn">Created On </label>
                            <InputText id="createdOn" name="createdOn" value={formik.values.createdOn} onChange={formik.handleChange} disabled />
                        </div>
                        <div className="col-4 mb-3">
                            <label htmlFor="lastUpdated">Last Updated </label>
                            <InputText id="lastUpdated" name="lastUpdated" value={formik.values.lastUpdated} onChange={formik.handleChange} disabled />
                        </div>
                         <div className="col-4 mb-3">
                            <label htmlFor="lastUpdatedBy"> Last Updated By </label>
                            <InputText id="lastUpdatedBy" name="lastUpdatedBy" value={formik.values.lastUpdatedBy} onChange={formik.handleChange}  disabled />
                        </div>
                    </>
                )}

                {/* <div className="col-12 mb-2">
                    <label htmlFor="additionalFields"> Additional Info </label>
                    <DynamicInput fieldArr={additionalFields} handleChange={handleDynamicInputChange} isViewMode={isViewMode} />
                </div> */}

            </div>
        );
    };

    const renderMainButton = () => {
        return (
            <>
                {!isViewMode && 
                    <Button label={isEditMode ? 'Update' : 'Save'} 
                    data-pr-tooltip={isEditMode ? 'Update' : 'Save'}
                    severity="success" outlined className="p-button-success tp"
                    icon="pi pi-save" type="submit"/>
                }
                <Button
                    label={isViewMode ? 'Back' : 'Cancel'}
                    severity="secondary" outlined
                    icon={isViewMode ? 'pi pi-arrow-left' : 'pi pi-times'}
                    className="p-button-secondary tp" type="button"
                    data-pr-tooltip={isViewMode ? 'Back' : 'Cancel'}
                    onClick={() => navigate('/ui/store-system-id-config')}
                />
            </>
        );
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="form_height px-2 mt-2">
                    <div className="d-flex flex-row gap-10 align-items-center mb-1">
                        <h2 className="page-header mr-auto">
                            {isEditMode
                                ? `Edit Store : ${formik.values.storeId }`
                                : 'Store Details'}
                        </h2>
                        {renderMainButton()}
                    </div>
                    <div className="grid px-2">
                        <div className="col-12">{renderFormArea()}</div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default StoreSystemIdDetails;
